import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLanguage } from "../contexts/LanguageContext";
import { selectIsAuthenticated, selectAuthLoading } from "../redux/slices/authSlice";

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const { getLocalizedPath } = useLanguage();
    const loading = useSelector(selectAuthLoading);

    console.log(
        "ProtectedRoute - loading:",
        loading,
        "isAuthenticated:",
        isAuthenticated
    );
    console.log("ProtectedRoute - pathname:", location.pathname);

    // Show loading while authentication state is being determined
    if (loading) {
        return (
            <div className="dashboard-loading">
                <div className="loading-container">
                    <div className="loading-spinner"></div>
                    <p>Loading dashboard...</p>
                </div>
            </div>
        );
    }

    // Only redirect to login if trying to access dashboard routes and user is not authenticated
    const isDashboardPath =
        location.pathname.startsWith("/dashboard") ||
        location.pathname.startsWith("/ar/dashboard");

    if (!isAuthenticated && isDashboardPath) {
        console.log("ProtectedRoute - redirecting to login");
        return (
            <Navigate
                to={getLocalizedPath("/login")}
                state={{ from: location }}
                replace
            />
        );
    }

    console.log("ProtectedRoute - allowing access");
    return children;
};

export default ProtectedRoute;
